import axios from 'axios'
import jwt from 'jsonwebtoken'
import { Message } from 'element-ui'

export default {
  install(Vue, options) {
    /**
     * initialize HTTPClient
     */
    const HTTP = axios.create({
      baseURL: options.baseURL,
      validateStatus: function(status) {
        return status >= 200 && status < 500
      }
    })

    /**
     * resign new requests with current auth token
     */
    HTTP.interceptors.request.use(config => {
      return config
    })

    /**
     * error handling
     */
    const onError = e => {
      console.error('API HTTP Error', e)
    }

    /**
     * generic request
     */
    const request = async (method, url, data, params) => {
      try {
        const response = await HTTP.request({ method, url, data, params })
        if (response.status < 300) return response.data
        if (response.status === 401) {
          Message({
            message: response.data.message || 'Authentication Error',
            type: 'error',
            duration: 3500,
            showClose: true
          })
          return options.store.dispatch('logout')
        }
        if (response.status === 403) {
          Message({
            message: response.data.message || 'Forbidden',
            type: 'error',
            duration: 3500,
            showClose: true
          })
          // return options.store.dispatch('logout')
        }
        if (response.status >= 400) {
          Message({
            message: response.data.message || 'An unknown error occured',
            type: 'error',
            duration: 3500,
            showClose: true
          })
        }
      } catch (e) {
        onError(e)
      }
    }

    const refreshToken = async () => {
      const token = options.store.state.token
      if (token) {
        const decoded = jwt.decode(token)
        if (Date.now() - decoded.exp * 1000 < 0) {
          const result = await request('post', 'refresh', { token })
          options.store.commit('setToken', result.token)
        }
      }
    }

    setInterval(refreshToken, 30 * 1000)

    const updateStatus = async () => {
      const response = await request('get', 'status')
      if (response && response.status) {
        options.store.dispatch('updateStatus', response)
      }
    }

    /**
     * expose api[Post|Get|etc.]
     */
    Vue.prototype.apiPost = async (url, data) => {
      const response = await request('post', url, data)
      updateStatus()
      return response
    }

    Vue.prototype.apiPut = async (url, data) => {
      const response = await request('put', url, data)
      updateStatus()
      return response
    }

    Vue.prototype.apiGet = async (url, params, doUpdateStatus = true) => {
      const response = await request('get', url, null, params)
      if (doUpdateStatus) updateStatus()
      return response
    }

    Vue.prototype.apiDelete = async url => {
      const response = await request('delete', url)
      updateStatus()
      return response
    }
  }
}



// WEBPACK FOOTER //
// ./src/api.js